export default __webpack_public_path__ + "static/media/ic_england.ebda72fb.svg";